module.exports = __webpack_public_path__ + "img/service-points.529a962.webp";